import { useCallback } from "react";

import { useQuery } from "hooks";

import { createResolverFactory } from "../../Workspace/components/WorkflowContainer/components/FormFieldBuilder/hooks";

export function useGetHouseholdRoles() {
  const queryFactory = useCallback(() => {
    const query = `
      query getHouseholdRoles {
        householdRoles
      }`;

    const resolver = ({ data: { householdRoles } }) => {
      return householdRoles;
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  return useQuery(queryFactory);
}

export default useGetHouseholdRoles;
